<template>
    <div class="container-utility-list">
        <!--        <div class="box-utility list" :class="{'disabled':returnDisalbe(data)}" v-for="(data,index) in utilityData"
                     :key="`${index}boxUtility`" @click="$router.push(`/utility/${data.u_idx}`)">
                    <div class="img-utility" :style="`background-image : url(${returnImg(data.UtilityImg[0])})`">
                        <div class="category-utility">{{ data.uc_name }}</div>
                        <div class="condition-utility"
                             :class="returnState(data.u_is_use, data.u_use_start_date, data.u_use_end_date)">
                            {{ $t(returnStateText(data.u_is_use, data.u_use_start_date, data.u_use_end_date)) }}
                        </div>
                    </div>
                    <div class="wrap-content-utility">
                        <div class="text-utility-top">Utility</div>
                        <div class="title-utility">{{ data.u_name }}</div>
                        <div class="wrap-profile-utility">
        &lt;!&ndash;                    <div class="img-profile-utility"
                                 :style="`background-image : url(${returnImg(data.collectionImg[0])})`"></div>
                            <div class="text-profile-utility">{{ data.c_title }}</div>&ndash;&gt;
                        </div>
                        <div class="wrap-info-utility">
                            <div class="text-cnt-utility"> {{ `${data.u_use_total}/${data.u_publish_total}` }}</div>
                            <div class="wrap-mingle-utility">
                                <div class="icon-mingle-utility"></div>
                                <div class="text-mingle-utility">{{ data.u_price }} Mg</div>
                            </div>
                            <div class="text-price-utility">({{ returnMingle(data.u_price) }})</div>
                        </div>
                    </div>
                </div>-->
        <div class="wrap-nticket-common mb10" v-for="(data,index) in utilityData" @click="$router.push(`/utility/${data.u_idx}`)">
            <ticket-image
                :svgWidth="ticketWidth"
                :ticketLeftColor="'#007B94'"
                :ticketRightColor="'#FFF'"
            ></ticket-image>
            <div class="category-nticket-common">
                <div class="text-category-nticket">{{
                        isKorean(data.uc_name, data.uc_name_eng)
                    }}
                </div>
            </div>
            <div class="info-nticket-common">
                <div class="fg-1 pl10 pr10 of-hidden">
                    <div class="pb4 fz15 fw500 one-ellipsis zoom-common">{{ data.u_name }}</div>
                    <div class="box-flex pb10">
                        <div class="icon-mingle-utility"></div>
                        <div class="fz13 fw700 c33 one-ellipsis zoom-common">{{ data.u_price }} Mg</div>
                        <div class="fz11 c80 pl3 one-ellipsis zoom-common">(￦ {{ data.u_price * 10 }})</div>
                    </div>
                    <div class="box-flex f-wrap zoom-common">
                        <div class="icon-nticket-share main-icon" v-if="data.Collections.Main.length>0"
                             :style="`background-image : url('${returnNewImage(data.Collections.Main[0],'MainFile')}')`"></div>
                        <div class="fz11 fw500 c66 pl4 pr3" v-if="data.Collections.Main.length>0">
                            {{ $t('other_things', {data: data.Collections.Main[0].c_title}) }}
                        </div>
                        <div
                            v-if="data.Collections.Sub.length>0"
                            class="fz11 fw500 c66 pr3"
                        >{{ $t('counts_collection', {count: data.Collections.Sub.length}) }}
                        </div>
                        <div class="box-flex">
                            <div class="box-flex pl6">
                                <div class="icon-nticket-share"
                                     :style="`background-image : url('${returnNewImage(subCollection, 'MainFile')}')`"
                                     v-for="(subCollection, collectionIndex) in data.Collections.Sub"
                                     :key="`${collectionIndex}popularMainUtilityDetail`"
                                ></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="image-nticket-common" :style="`background-image : url('${returnImg(data.UtilityImg[0])}')`">
                    <div class="box-image-nticket">
                        <div class="icon-12-common heart"></div>
                        <div class="pl2 fz12 fw500 c80">{{ returnCnt(data.Like.cnt) }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>


<script>
import util from "@/mixins/util";
import dateMixins from "@/mixins/dateMixins";
import priceMixins from "@/mixins/priceMixins";
import {mapState} from "vuex";
import TicketImage from "@/components/element/TicketImage.vue";

export default {
    name: "UtilityListDefaultLayout.vue",
    mixins: [dateMixins, priceMixins],
    components: {TicketImage},
    props: {
        utilityData: {
            default: () => []
        },

    },
    data() {
        return {
            ticketWidth: (1200 - 60) / 3,
        }
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {

    },
    beforeUnmount() {
    },
    unmounted() {
    },
    computed: {
        ...mapState({
            UserInfo: state => state.userInfo.UserInfo,
        })
    },
    methods: {
        returnImg(data) {
            if (!util.isEmpty(data)) {
                return data.org_url;
            } else {
                return '';
            }
        },
        returnDisalbe(data) {
            let now = this.returnDateTime(new Date());

            if (!util.isEmpty(data) && (data.u_use_end_date < now || data.u_is_use == 0)) {
                return true;
            }
        },
        returnState(state, start, end) {
            let now = this.returnDateTime(new Date());

            if (state === 1) {
                if (start > now) {
                    return 'waiting'; // 사용대기
                } else if (start < now && end > now) {
                    return 'possible'; // 사용가능
                } else if (end < now) {
                    return 'already'; //기한만료
                }
            } else {
                return 'used'; // 사용완료
            }
        },
        returnStateText(state, start, end) {
            let now = this.returnDateTime(new Date());

            if (state === 1) {
                if (start > now) {
                    return 'use_await'; // 사용대기
                } else if (start < now && end > now) {
                    return 'use_possible'; // 사용가능
                } else if (end < now) {
                    return 'use_end_already'; //기한만료
                }
            } else {
                return 'use_fin'; // 사용완료
            }
        },

        isKorean(korean, english) {
            let lang = this.$i18n.locale;
            return this.UserInfo.ma_language == 1 || lang == 'ko'
                ? korean
                : english
                    ? english
                    : korean;
        },
        returnCnt(item) {
            if (item > 999) {
                return '999+';
            } else {
                return item;
            }
        },
        returnNewImage(data, key) {
            if (!util.isEmpty(data) && !util.isEmpty(data[key][0]) && data[key][0].a_idx > 0) {
                return `${data[key][0].org_url}`;
            } else {
                return '';
            }
        },
    },
    watch: {},
}
</script>
